<template lang="html">
  <d-card class="card-small mb-4">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" lg="4">
          <h6 class="m-0">Lista de Equipamentos</h6>
        </d-col>
      </d-row>
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col md="12">
            <table class="table mb-0 table-striped">
              <tbody>
                <tr>
                  <td>
                    <ul class="options">
                      <li v-for="option in model.equipments" :key="option.id">
                        <span class="label delete" @click="deleteOption(option)"><i class="material-icons">delete</i></span>
                        <span class="label" @click="openOption(option)">{{ option.name }}</span>
                      </li>
                      <li>
                        <span class="label" @click="openOption()">+ Novo equipamento</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </d-col>
        </d-row>
        <d-row v-if="model.equipments.length == 0">
          <d-col class="no-content p-4">Ainda não foram cadastrados nenhum equipamento.</d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
    <add-equipment-modal/>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import AddEquipmentModal from '_modules/product/components/modal/AddEquipmentModal.vue';
import {
  _LOAD_EQUIPMENT_,
  _RELOAD_EQUIPMENT_,
  PRODUCT_TYPE_OPTIONS,
  MODEL,
  _DELETE_PRODUCT_EQUIPMENT_,
} from './ProductModel';

export default {
  name: 'variations',
  props: {
    model: {
      type: Object,
      default: cloneDeep(MODEL),
    },
  },
  components: {
    AddEquipmentModal,
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    deleteOption(option) {
      Events.$emit(_DELETE_PRODUCT_EQUIPMENT_, { productId: this.model.id, id: option.id });
      this.setToggle({ type: 'confirm_modal', bool: true });
    },
    updateEquipments(equipment) {
      let index = Object.values(this.model.equipments).findIndex(row => row.id === equipment.id);
      if (index === -1) {
        index = this.model.equipments.length;
      }
      this.$set(this.model.equipments, index, equipment);
      this.$emit('update:model', this.model);
    },
    openOption(option = PRODUCT_TYPE_OPTIONS) {
      Events.$emit(_LOAD_EQUIPMENT_, { id: this.model.id, option });
      this.setToggle({ type: 'add_equipment_modal', bool: true });
    },
  },
  mounted() {
    Events.$on(_RELOAD_EQUIPMENT_, equipment => {
      this.updateEquipments(equipment);
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.col {
  &-2 {
    width: 25%;
  }
  &-8 {
    width: 75%;
  }
}

.align-center {
  vertical-align: middle;
}
.delete {
  cursor: pointer;
  margin-right: 7px;
}
.options {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: center;
  margin-bottom: 0;
  padding-left: 0;
  li {
    padding: 5px;
    border: 1px dashed #ff6d00;
    border-radius: 4px;
    margin-right: 5px;
    margin-bottom: 10px;
    background: $info;
    color: #ff6d00;
    font-size: 12px;
    cursor: pointer;
    &:hover {
      background: #ff6d00;
      color: #ffffff;
    }
  }
}
</style>
